module.exports = __webpack_public_path__ + "img/play.8a617c3.svg";